import React from 'react';
import Modal from 'react-modal';

const dialog = (props) => {
  const handleButtonTwoClick = (e) => {
    props.onButtonTwoClick(props.buttonTwoAction, e);
    props.onRequestClose();
  };
  const buttonTwo = props.buttonTwo ? 
    (<button className="button" onClick={(e) => handleButtonTwoClick(e)}>{props.buttonTwo}</button>) : null;
  return (
    <Modal isOpen={props.isOpen}
      className="Modal"
      contentLabel={props.contentLabel}
      appElement={document.getElementById(props.appElement)}>
      <h2>{props.contentLabel}</h2>

      <div dangerouslySetInnerHTML={{ __html:props.children}} />

      <div className="buttonsRow">
        <button className="button"
          onClick={props.onRequestClose}>{props.button}</button>
        { buttonTwo }
      </div>
    </Modal>
  );
};

export default dialog;
